import { IonCol, IonGrid, IonRow, isPlatform } from "@ionic/react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import React, {
  ChangeEvent,
  forwardRef,
  ReactNode,
  SetStateAction,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { GenerateGUID } from "../Common";

import api from "./../../services/api";

// import { v4 as uuidv4, v4 } from "uuid";

type Props = {
  setTitleId: React.Dispatch<React.SetStateAction<number | undefined>>;
  width?: string;
  fullWidth?: boolean;
  checked: boolean;
};

type Option = {
  id: number;
  value: string;
}

const PunishmentsAutocomplete: React.FC<Props> = ({
  setTitleId,
  width,
  checked,
  fullWidth = false,
}) => {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<readonly Option[]>([]);
  const loading = open && options.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    api.get("autocomplete/note-titles").then((response) => {
      setOptions(response.data);
    });

    // setOptions([
    //   "Niedowóz",
    //   "Pomylona kaloryczność",
    //   "Pomylony typ diety",
    //   "Uszkodzona tacka",
    // ]);

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <Autocomplete
      freeSolo={checked}
      noOptionsText="Nie znaleziono"
      // id={v4()}
      sx={{
        width: {
          xs: "100%",
          sm: "100%",
          md: "100%",
        },
      }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      isOptionEqualToValue={(option, value) => option === value}
      getOptionLabel={(option) => {
        return (option as Option).value;
      }}
      onChange={(event, value) => {
        setTitleId((value as Option).id);
      }}
      options={options}
      loading={loading}
      renderInput={(params) => (
        <TextField
          variant="filled"
          type={"search"}
          className="shadow-mui"
          {...params}
          id={GenerateGUID()}
          autoComplete={GenerateGUID()}
          label="Tytuł"
          fullWidth={true}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default PunishmentsAutocomplete;
